import { Info } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ResponsiveFormModal } from '@/components/commons'
import { Button } from '@/components/ui/button'

const ACCESS_RULES = ['creator', 'followUp', 'others'] as const

/** Ícone "i" que abre o popup explicando quem pode ver o emociograma (regra de acesso do backend). */
export function DdsEmotionAccessInfo() {
	const { t } = useTranslation()
	const [open, setOpen] = useState(false)

	return (
		<>
			<Button
				aria-label={t('ddsEmotions.accessInfo.title')}
				className="text-kaefer-medium-grey"
				onClick={() => setOpen(true)}
				size="icon"
				title={t('ddsEmotions.accessInfo.title')}
				type="button"
				variant="ghost"
			>
				<Info className="size-5" />
			</Button>

			<ResponsiveFormModal
				cancelLabel={t('ddsEmotions.accessInfo.close')}
				onCancel={() => setOpen(false)}
				onOpenChange={setOpen}
				open={open}
				title={t('ddsEmotions.accessInfo.title')}
			>
				<div className="flex flex-col gap-3 text-kaefer-dark-grey text-sm">
					<p>{t('ddsEmotions.accessInfo.intro')}</p>
					<ul className="flex list-disc flex-col gap-2 pl-5">
						{ACCESS_RULES.map((rule) => (
							<li key={rule}>{t(`ddsEmotions.accessInfo.rules.${rule}`)}</li>
						))}
					</ul>
					<p className="text-muted-foreground text-xs">
						{t('ddsEmotions.accessInfo.note')}
					</p>
				</div>
			</ResponsiveFormModal>
		</>
	)
}
